import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import get from 'lodash/get';
import ClientCode from '../../../../clientCode/ClientCode';

class EmailAttachmentPurchaseForm extends Component {
  renderAlreadyPurchased = () => {
    const { entries, selectedDocket, emailActionName } = this.props;
    const { pdf_filename, pdf_download_url, zip_filename, zip_download_url } = entries.data.find(
      docket => docket.docket_seq === selectedDocket.docket_seq
    );

    if (emailActionName === 'emailPartsPdfCombined' && pdf_filename && pdf_download_url) {
      return <a href={pdf_download_url}>{pdf_filename}</a>;
    }
    if (emailActionName === 'emailPartsZip' && zip_filename && zip_download_url) {
      return <a href={zip_download_url}>{zip_filename}</a>;
    }
    return <div>Already Purchased</div>;
  };

  render() {
    const { docketParts } = this.props;
    const { partsToPurchase, totalCost, totalParts, errors, step, status, purchased, alreadyPurchased } = docketParts;

    return (
      <div className="inner-text">
        {this.props.showXfaWarning && (
          <div className="warning">PDF combining currently does not support XFA documents.</div>
        )}
        {errors && (
          <div className="error">
            {errors.map(error => (
              <span>
                {error}
                <br />
              </span>
            ))}
          </div>
        )}
        {(step === 1 || step === 0) && status === 'loading' && (
          <div>
            <div>Checking price of all PDFs...</div>
            <ProgressBar now={100} active />
          </div>
        )}
        {step === 1 && partsToPurchase > 0 && (
          <Fragment>
            <div>
              Need to purchase {partsToPurchase} / {totalParts} PDFs from PACER.
            </div>
            <div className="email-bulk-buy-container">
              {partsToPurchase > 0 && (
                <ClientCode
                  initialClientCode=""
                  isClientCodeLocked={get(window, 'Drupal.settings.isClientCodeLocked')}
                  className="bulk-client-code"
                  span
                  ignoreClientCodeAutosetMsg
                />
              )}
              <button className="form-submit green next uy-btn email-bulk-buy-button" onClick={this.props.buy}>
                Buy ${(totalCost || 0).toFixed(2)}
              </button>
            </div>
          </Fragment>
        )}
        {alreadyPurchased && this.renderAlreadyPurchased()}
        {step === 2 && (
          <Fragment>
            {purchased > 0 && <div>Purchased {purchased} PDFs</div>}
            {status === 'loading' && (
              <div>
                <div>Purchasing PDFs...</div>
                <ProgressBar now={100} active />
              </div>
            )}
          </Fragment>
        )}
        {step === 3 && status === 'loading' && (
          <div>
            <div>Sending...</div>
            <ProgressBar now={100} active />
          </div>
        )}
      </div>
    );
  }
}

EmailAttachmentPurchaseForm.defaultProps = {
  showXfaWarning: false,
};

EmailAttachmentPurchaseForm.propTypes = {
  docketParts: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  entries: PropTypes.object.isRequired,
  buy: PropTypes.func.isRequired,
  showXfaWarning: PropTypes.bool,
  emailActionName: PropTypes.string.isRequired,
};

export default EmailAttachmentPurchaseForm;



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailAttachmentPurchaseForm.jsx